import { QueryClient } from '@tanstack/react-query';
import { HttpError } from './HttpError';

const shouldRetry = (failureCount: number, error: unknown): boolean => {
  if (error instanceof HttpError) {
    if (error.isUnauthorized || error.isForbidden || error.isNotFound) return false;
    if (error.isClientError) return false;
  }
  return failureCount < 2;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: shouldRetry,
    },
    mutations: {
      retry: false,
    },
  },
});
